export default "__VITE_ASSET__BdUwogBl__"